import { safeParseUrl } from "@tldraw/editor";
function escapeStringRegexp(string) {
  if (typeof string !== "string") {
    throw new TypeError("Expected a string");
  }
  return string.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
}
function matchEmbedUrl(definitions, url) {
  const parsed = safeParseUrl(url);
  if (!parsed) return void 0;
  const host = parsed.host.replace("www.", "");
  for (const localEmbedDef of definitions) {
    if (checkHostnames(localEmbedDef.hostnames, host)) {
      const originalUrl = localEmbedDef.fromEmbedUrl(url);
      if (originalUrl) {
        return {
          definition: localEmbedDef,
          url: originalUrl,
          embedUrl: url
        };
      }
    }
  }
  return void 0;
}
const globlikeRegExp = (input) => {
  return input.split("*").map((str) => escapeStringRegexp(str)).join(".+");
};
const checkHostnames = (hostnames, targetHostname) => {
  return !!hostnames.find((hostname) => {
    const re = new RegExp(globlikeRegExp(hostname));
    return targetHostname.match(re);
  });
};
function matchUrl(definitions, url, embedConfig) {
  const parsed = safeParseUrl(url);
  if (!parsed) return void 0;
  const host = parsed.host.replace("www.", "");
  for (const localEmbedDef of definitions) {
    if (checkHostnames(localEmbedDef.hostnames, host)) {
      const embedUrl = localEmbedDef.toEmbedUrl(url, embedConfig?.[localEmbedDef.type]);
      if (embedUrl) {
        return {
          definition: localEmbedDef,
          embedUrl,
          url
        };
      }
    }
  }
  return void 0;
}
function getEmbedInfo(definitions, inputUrl, embedConfig) {
  try {
    return matchUrl(definitions, inputUrl, embedConfig) ?? matchEmbedUrl(definitions, inputUrl);
  } catch {
    return void 0;
  }
}
const ASPECT_RATIO_EPSILON = 1e-3;
function getCorrectedEmbedSize({
  w,
  h,
  resolvedRatio
}) {
  if (!resolvedRatio || resolvedRatio <= 0) return null;
  if (Math.abs(w / h - resolvedRatio) <= ASPECT_RATIO_EPSILON) return null;
  const area = w * h;
  return { w: Math.sqrt(area * resolvedRatio), h: Math.sqrt(area / resolvedRatio) };
}
export {
  getCorrectedEmbedSize,
  getEmbedInfo,
  matchEmbedUrl,
  matchUrl
};
//# sourceMappingURL=embeds.mjs.map
